module.exports = __webpack_public_path__ + "static/media/IconRedeEsgoto.f10f1e1a.svg";